export default {
    "name": "HomeWorkOrderDefaults",
    "kind": "HoudiniQuery",
    "hash": "78d8fd44c6f790fd7fcbf6f004f4a2eafc2df0887de480ead18324e4b02ebf6b",

    "raw": `query HomeWorkOrderDefaults {
  settingValues {
    home {
      defaultWorkOrderHistoryDateRange
    }
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "settingValues": {
                "type": "SettingValues",
                "keyRaw": "settingValues",

                "selection": {
                    "fields": {
                        "home": {
                            "type": "HomeSettingValues",
                            "keyRaw": "home",

                            "selection": {
                                "fields": {
                                    "defaultWorkOrderHistoryDateRange": {
                                        "type": "String",
                                        "keyRaw": "defaultWorkOrderHistoryDateRange",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=fb38ce8fa44a56d9aeeada8b00a3bf627832b7578093fa45e6fc134b6b51a81c";